import axiosInstance from 'api/axiosInstance';

const deleteTag = (tagId: string) =>
  axiosInstance.delete(`/v2/repository-document-tags/${tagId}`);

export default deleteTag;
